import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { Color } from '@/routes/Requests/Request/Article/Color';
import Size from '@/routes/Requests/Request/Article/Size';
import { Weight } from '@/routes/Requests/Request/Article/Weight';

export const ColorSizeWeight = () => {
  const { view } = useArticleContext();

  return (
    <>
      {view.details.color.shown && <Color />}

      {view.details.size.shown && <Size />}

      {view.details.weight.shown && <Weight />}
    </>
  );
};
